/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, applyEach, maxLength, min, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusCreatePrivacyPolicyDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusCreatePrivacyPolicyDtoInitialValue(): LexplusCreatePrivacyPolicyDto {
  return {
  version: 0,
  uebersetzungen: [],
} as LexplusCreatePrivacyPolicyDto;
}

/**
 * Reusable Signal Forms schema for LexplusCreatePrivacyPolicyDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusCreatePrivacyPolicyDtoSchema(path: SchemaPathTree<LexplusCreatePrivacyPolicyDto>): void {
  required(path.version);
  min(path.version, 1);
  applyEach(path.uebersetzungen, (item) => {
    required(item.spracheLokalisierung);
    required(item.titel);
    maxLength(item.titel, 256);
  });
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusCreatePrivacyPolicyDtoForm(initial?: Partial<LexplusCreatePrivacyPolicyDto>) {
  const model: WritableSignal<LexplusCreatePrivacyPolicyDto> = signal<LexplusCreatePrivacyPolicyDto>({
    ...getLexplusCreatePrivacyPolicyDtoInitialValue(),
    ...initial,
  } as LexplusCreatePrivacyPolicyDto);
  return { model, field: form(model, lexplusCreatePrivacyPolicyDtoSchema) };
}
